module.exports = __webpack_public_path__ + "img/email_icon.5706d12d.svg";